/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit NoteTemplate/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromFlow from 'Simple/Flow'
import Content from './Content/index'
import No from './No/index'
import React from 'react'



/** @type {import('Simple/types.js').View} */
export default function NoteTemplate({
  children,
  viewPath = "/App/Account/Content/Calendar/New/AppointmentOverlay/Content/AdditionalOptions/Content/AddNoteAction/Content/NotesInput/NoteTemplate"
  
}) {
  let flowValue = fromFlow.useFlowValue(viewPath) || 'No'
let editorNoteTemplateUrlValueData = fromData.useDataValue({ viewPath,
context: 'editor',
path: 'note_template_url',
})
fromData.useSetFlowToBasedOnDataValue({ viewPath,
value: Boolean(editorNoteTemplateUrlValueData),
})
  return (<React.Fragment
>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}